import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ThemeColorPipe } from 'src/app/core/utils/theme/theme-color.pipe';
import { DatepickerComponent } from '../form-kit/datepicker/datepicker.component';
import { TimepickerComponent } from '../form-kit/timepicker/timepicker.component';
import { DateTimePickerComponent } from './date-time-picker.component';

@NgModule({
  declarations: [DateTimePickerComponent],
  imports: [
    CommonModule,
    DatepickerComponent,
    TimepickerComponent,
    ThemeColorPipe,
  ],
  exports: [DateTimePickerComponent],
})
export class DateTimePickerModule {}
